import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Paper,
  Toolbar,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Snackbar,
  IconButton,
  Chip,
} from "@mui/material";
import {
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
} from "@mui/material";

import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import MuiAlert from "@mui/material/Alert";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import VerifiedIcon from "@mui/icons-material/Verified";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";
import EvaluationViewer from "./EvaluationViewer";

export default function ScriptValuation() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [startTime, setStartTime] = useState(null);
  // NEW STATE - course selection
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedCourseName, setSelectedCourseName] = useState(null);
  const [selectedCourseCode, setSelectedCourseCode] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState({});
  const [staffList, setStaffList] = useState([]);
  const [scrutinyDialogOpen, setScrutinyDialogOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const roleId = user.role_id || user.core_user_roles?.[0]?.role_id;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const showSnackbar = (msg, severity = "success") => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };
  const handleStartEvaluation = (row) => {
    setStartTime(Date.now());
    setSelectedScript(row);
  };

  function getTimetableIdFromFile(pdfFileName) {
    if (!pdfFileName) return null;
    const match = pdfFileName.match(/HT-[^-]+-(\d+)\.pdf$/);
    return match ? Number(match[1]) : null;
  }
  const fetchScrutinyStaff = async () => {
    try {
      const staff_type = "T";
      const res = await axios.get(
        `${API_BASE_URL}/api/staff/scrutiny-staff/${user.client_id}/${user.college_id}/${staff_type}`
      );

      setStaffList(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCourseSelection = (courseId, checked) => {
    if (checked) {
      setSelectedCourses((prev) => [...prev, courseId]);
    } else {
      setSelectedCourses((prev) => prev.filter((id) => id !== courseId));
    }
  };
  // Fetch scripts
  const fetchScripts = async () => {
    setLoading(true);
    try {
      let data = null;

      if (roleId == 6) {
        data = await axios.get(
          `${API_BASE_URL}/api/script-valuation/userwise/${user.client_id}/${user.college_id}/${user.user_email}`
        );
      } else if (roleId == 16) {
        data = await axios.get(
          `${API_BASE_URL}/api/script-valuation/userwise/${user.client_id}/${user.college_id}/${user.user_email}`
        );
      } else {
        data = await axios.get(
          `${API_BASE_URL}/api/script-valuation/collegewise/${user.client_id}/${user.college_id}`
        );
      }
      //console.log(data.data.data.items);
      if (data.data.success) {
        const updatedRows = (data.data.data.items || []).map((item) => ({
          ...item,
          exam_schedule_master_id: item.allocation?.exam_schedule_master_id ?? null,
          valuation_schedule_master_id: item.allocation?.valuation_schedule_master_id ?? null,
          exam_month: item.allocation?.schedule?.exam_month,
          exam_type: item.allocation?.schedule.exam_type?.exam_type_name,
          year_number: item.allocation?.schedule?.exam_schedule_details[0]?.year_number,
          semester_number: item.allocation?.schedule?.exam_schedule_details[0]?.semester_number,
          exam_course_id: item.allocation?.exam_course_id ?? null,
          timetable_id: getTimetableIdFromFile(item.script_pdf),
          course_code: item.allocation?.course?.course_code ?? null,
          course_name: item.allocation?.course?.course_name ?? null,
          staff_name: item.allocation?.external_staff?.staff_name ?? null,
          personal_mobile: item.allocation?.external_staff?.personal_mobile ?? null,
          student_rollno: item.student?.student_rollno ?? null,
          scrutiny_staff_id: item.allocation?.scrutiny_staff_id ?? null,

          scrutiny_staff_name: item.allocation?.internal_staff?.staff_name ?? null,

          scrutiny_staff_mobile: item.allocation?.internal_staff?.mobile ?? null,

          valuation_type: item.allocation?.valuation_schedule?.valuation_type ?? null,
          revaluation_round: item.allocation?.valuation_schedule?.revaluation_round ?? null,
        }));
        setRows(updatedRows);
      } else {
        showSnackbar(data.message || "Error: Failed to load scripts", "error");
      }
    } catch (err) {
      console.error(err);
      showSnackbar("Script details not found for this email. ", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScripts();
  }, []);
  const schedules = useMemo(() => {
    const map = {};

    rows.forEach((r) => {
      const key = `${r.exam_schedule_master_id}_${r.valuation_schedule_master_id}`;

      if (!map[key]) {
        map[key] = [];
      }

      map[key].push(r);
    });

    return map;
  }, [rows]);
  // GROUP rows by exam_course_id
  const groupCourses = (scheduleRows) => {
    const map = {};

    scheduleRows.forEach((r) => {
      const key = `${r.exam_schedule_master_id}_${r.valuation_schedule_master_id}_${r.exam_course_id}`;

      if (!map[key]) {
        map[key] = {
          exam_schedule_master_id: r.exam_schedule_master_id,

          valuation_schedule_master_id: r.valuation_schedule_master_id,

          exam_month: r.exam_month,
          exam_type: r.exam_type,

          semester_number: r.semester_number,
          year_number: r.year_number,

          exam_course_id: r.exam_course_id,
          course_code: r.course_code,
          course_name: r.course_name,
          valuation_type: r.valuation_type,
          revaluation_round: r.revaluation_round,
          staff_name: r.staff_name,
          personal_mobile: r.personal_mobile,
          scrutiny_staff_id: r.scrutiny_staff_id,
          scrutiny_staff_name: r.scrutiny_staff_name,
          scrutiny_staff_mobile: r.scrutiny_staff_mobile,
          assigned: r.scrutiny_staff_id != null,
          total: 0,
          pending: 0,
          completed: 0,
          verified: 0,
        };
      }

      map[key].total += 1;

      switch (r.evaluation_status) {
        case "PENDING":
          map[key].pending += 1;
          break;

        case "COMPLETED":
          map[key].completed += 1;
          break;

        case "VERIFIED":
          map[key].verified += 1;
          break;

        default:
          break;
      }
    });

    return Object.values(map);
  };
  // Already assigned courses should be checked
  /*  useEffect(() => {
     const assignedCourses = {};
 
     Object.keys(schedules).forEach((scheduleKey) => {
       const groupedCourses = groupCourses(schedules[scheduleKey]);
 
       assignedCourses[scheduleKey] = groupedCourses
         .filter((course) => course.scrutiny_staff_id)
         .map((course) => course.exam_course_id);
     });
 
     setSelectedCourses(assignedCourses);
   }, [schedules]); */

  const handleSaveScrutinyStaff = async () => {
    if (!selectedSchedule) {
      showSnackbar("Schedule not selected", "error");
      return;
    }

    try {
      const scheduleKey = `${selectedSchedule.exam_schedule_master_id}_${selectedSchedule.valuation_schedule_master_id}`;

      const examCourseIds = selectedCourses[scheduleKey] || [];

      if (examCourseIds.length === 0) {
        showSnackbar("Please select at least one course", "error");
        return;
      }

      await axios.put(
        `${API_BASE_URL}/api/script-valuation/assign-scrutiny-staff/${user.client_id}/${user.college_id}`,
        {
          exam_schedule_master_id: selectedSchedule.exam_schedule_master_id,

          valuation_schedule_master_id: selectedSchedule.valuation_schedule_master_id,

          exam_course_ids: examCourseIds,

          scrutiny_staff_id: selectedStaff.staff_id,
        }
      );

      showSnackbar("Scrutiny Staff Assigned Successfully", "success");

      // Keep the SAME schedule open
      setExpandedAccordion(scheduleKey);

      // Close dialog
      setScrutinyDialogOpen(false);

      // Clear only selected courses for THIS schedule
      setSelectedCourses((prev) => {
        const updated = { ...prev };
        delete updated[scheduleKey];
        return updated;
      });

      setSelectedStaff(null);

      // Refresh data
      await fetchScripts();
    } catch (error) {
      console.error(error);

      showSnackbar(error?.response?.data?.message || "Failed to assign scrutiny staff", "error");
    }
  };
  const courseScripts = useMemo(() => {
    if (!selectedCourse || !selectedSchedule) return [];

    return rows.filter(
      (r) =>
        r.exam_course_id === selectedCourse &&
        r.exam_schedule_master_id === selectedSchedule.exam_schedule_master_id &&
        r.valuation_schedule_master_id === selectedSchedule.valuation_schedule_master_id
    );
  }, [rows, selectedCourse, selectedSchedule]);

  const filteredRows = useMemo(() => {
    if (!search) return courseScripts;
    const s = search.toLowerCase();
    return courseScripts.filter(
      (r) =>
        r.student_id?.toString().includes(s) ||
        r.student_rollno?.toString().includes(s) ||
        r.exam_barcode_id?.toString().includes(s) ||
        r.script_marks?.toString().includes(s) ||
        (r.remarks || "").toLowerCase().includes(s) ||
        (r.evaluation_status || "").toLowerCase().includes(s)
    );
  }, [search, courseScripts]);

  // PDF
  const handleViewPDF = (row) => {
    const url = `${API_BASE_URL}/${row.script_pdf_path}`;
    window.open(url, "_blank");
  };

  const handleEndEvaluation = (timeTakenMinutes) => {
    // Optional: call API to save time taken
    axios.post(`${API_BASE_URL}/api/script-valuation/update-time`, {
      valuation_script_detail_id: selectedScript.valuation_script_detail_id,
      time_taken_for_valuation: timeTakenMinutes,
    });

    setSelectedScript(null);
    fetchScripts(); // reload
  };

  const scriptColumns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 70,
      valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
    },
    { field: "student_id", headerName: "Student ID", width: 100 },
    {
      field: "student_rollno",
      headerName: "Roll No",
      width: 180,
      renderCell: (params) =>
        roleId === 1 && params.row.evaluation_status === "VERIFIED"
          ? params.row.student_rollno
          : "****",
    },
    { field: "exam_barcode_id", headerName: "Barcode", width: 120 },
    { field: "script_marks", headerName: "Marks", width: 120 },
    { field: "time_taken_for_valuation", headerName: "Time (min)", width: 120 },
    {
      field: "evaluation_status",
      headerName: "Valuation Status",
      width: 160,
      renderCell: (params) => {
        const status = params.value;

        const statusColorMap = {
          PENDING: "warning", // orange
          VERIFIED: "success", // green
          COMPLETED: "info", // blue
        };

        return (
          <Chip
            label={status}
            size="medium"
            variant="outlined"
            sx={{
              fontWeight: 400,
              minWidth: 90,
              justifyContent: "center",

              backgroundColor:
                status === "PENDING"
                  ? "#fff3e0" // light orange
                  : status === "VERIFIED"
                  ? "#e8f5e9" // light green
                  : status === "COMPLETED"
                  ? "#e3f2fd" // light blue
                  : "#f5f5f5",

              color:
                status === "PENDING"
                  ? "#ed6c02"
                  : status === "VERIFIED"
                  ? "#2e7d32"
                  : status === "COMPLETED"
                  ? "#0288d1"
                  : "#757575",

              borderColor:
                status === "PENDING"
                  ? "#ed6c02"
                  : status === "VERIFIED"
                  ? "#2e7d32"
                  : status === "COMPLETED"
                  ? "#0288d1"
                  : "#bdbdbd",
            }}
          />
        );
      },
    },

    //{ field: "remarks", headerName: "Remarks", flex: 1.2 },

    /*{
      field: "pdf",
      headerName: "PDF",
      flex: 0.5,
      renderCell: (params) => (
        <IconButton color="error" size="medium" onClick={() => handleViewPDF(params.row)}>
          <PictureAsPdfIcon />
        </IconButton>
      ),
    },*/
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const status = params.row.evaluation_status;

        // 🔵 PENDING → Evaluate
        if (status === "PENDING" && roleId == 6) {
          return (
            <IconButton
              color="primary"
              size="medium"
              title="Evaluate"
              onClick={() => handleStartEvaluation(params.row)}
            >
              <PlayCircleIcon />
            </IconButton>
          );
        }

        // 🟢 COMPLETED → Verify
        if (status === "COMPLETED" && (roleId == 1 || roleId == 16)) {
          return (
            <IconButton
              color="success"
              size="medium"
              title="Verify"
              onClick={() => handleStartEvaluation(params.row)}
            >
              <VerifiedIcon />
            </IconButton>
          );
        }
        if (status === "VERIFIED" && roleId == 1) {
          return (
            <IconButton
              color="success"
              size="medium"
              title="View Verified"
              onClick={() => handleStartEvaluation(params.row)}
            >
              <VisibilityIcon />
            </IconButton>
          );
        }

        // ✅ VERIFIED → No action / locked
        return <VerifiedIcon color="disabled" titleAccess="Already Verified" />;
      },
    },
  ];
  const renderCountChip = (value, bg, color) => (
    <Chip
      label={value ?? 0}
      size="medium"
      sx={{
        fontWeight: 600,
        fontSize: "16px",
        minWidth: 60,
        backgroundColor: bg,
        color: color,
        justifyContent: "center",
      }}
    />
  );
  return (
    <Box p={2} sx={{ height: 560, width: "100%", gap: 1 }}>
      <Paper elevation={1}>
        {/* === Script Viewer === */}
        {selectedScript ? (
          <EvaluationViewer
            pdfUrl={`${selectedScript.script_pdf_path}`}
            questionPaperUrl={`${API_BASE_URL}/api/script-valuation/get-question-paper/${user.college_id}/${selectedScript.timetable_id}`}
            schemePaperUrl={`${API_BASE_URL}/api/script-valuation/get-scheme-paper/${user.college_id}/${selectedScript.timetable_id}`}
            startTime={startTime} // ⏱ Pass start time
            //onFinish={handleEndEvaluation} // ⏱ Callback for finish
            onClose={() => {
              setSelectedScript(null);
              fetchScripts();
            }}
            valuation_script_detail_id={selectedScript.valuation_script_detail_id}
            status={selectedScript.evaluation_status}
          />
        ) : !selectedCourse ? (
          /* === LAYER 1: COURSE LIST === */
          <Box sx={{ width: "100%" }}>
            <Toolbar>
              <Typography variant="h5">VALUATION COURSES</Typography>
            </Toolbar>

            {Object.keys(schedules).map((scheduleId) => {
              const scheduleRows = schedules[scheduleId];
              const groupedCourses = groupCourses(scheduleRows);

              const firstRow = scheduleRows?.[0];

              const examScheduleMasterId = firstRow?.exam_schedule_master_id;

              const valuationScheduleMasterId = firstRow?.valuation_schedule_master_id;

              const valuationType = firstRow?.valuation_type;
              const valuationRound = firstRow?.revaluation_round;

              const scheduleInfo = firstRow?.allocation?.schedule;
              const scheduleKey = scheduleId;

              const scheduleTotals = groupedCourses.reduce(
                (acc, course) => {
                  acc.total += Number(course.total || 0);
                  acc.pending += Number(course.pending || 0);
                  acc.completed += Number(course.completed || 0);
                  acc.verified += Number(course.verified || 0);
                  return acc;
                },
                {
                  total: 0,
                  pending: 0,
                  completed: 0,
                  verified: 0,
                }
              );
              return (
                <Accordion
                  key={scheduleId}
                  expanded={expandedAccordion === scheduleId}
                  onChange={handleAccordionChange(scheduleId)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      "& .MuiAccordionSummary-content": {
                        width: "100%",
                        margin: 0,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: { xs: 1, sm: 2 },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      {/* ---------- EXAM DETAILS ---------- */}
                      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Typography
                          variant="subtitle1"
                          fontWeight={600}
                          sx={{
                            fontSize: { xs: "13px", sm: "16px" },
                            lineHeight: 1.4,
                            wordBreak: "break-word",
                          }}
                        >
                          {scheduleInfo?.exam_month} -{" "}
                          {scheduleInfo?.exam_schedule_details?.[0]?.year_number} YEAR{" "}
                          {scheduleInfo?.exam_schedule_details?.[0]?.semester_number} SEMESTER{" "}
                          {scheduleInfo?.exam_type?.exam_type_name} - EXAMINATIONS
                        </Typography>

                        <Typography
                          variant="caption"
                          color="black"
                          sx={{
                            fontSize: { xs: "13px", sm: "13px" },
                            display: "block",
                            wordBreak: "break-word",
                          }}
                        >
                          Exam Schedule ID: {examScheduleMasterId} | Valuation Schedule ID:{" "}
                          {valuationScheduleMasterId} Valuation Type: {valuationType} Round:{" "}
                          {valuationRound}
                        </Typography>
                      </Box>

                      {/* ---------- SUMMARY / ACTIONS ---------- */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          flexWrap: "wrap",
                          alignItems: "center",
                          justifyContent: { xs: "flex-start", sm: "flex-end" },
                          width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        <Chip
                          size="medium"
                          label={`Scripts: ${scheduleTotals.total}`}
                          sx={{
                            bgcolor: "#e3f2fd",
                            color: "#0288d1",
                            fontWeight: 600,
                            fontSize: "11px",
                          }}
                        />

                        <Chip
                          size="medium"
                          label={`Pending: ${scheduleTotals.pending}`}
                          sx={{
                            bgcolor: "#fff3e0",
                            color: "#ed6c02",
                            fontWeight: 600,
                            fontSize: "11px",
                          }}
                        />

                        <Chip
                          size="medium"
                          label={`Completed: ${scheduleTotals.completed}`}
                          sx={{
                            bgcolor: "#e8f5e9",
                            color: "#2e7d32",
                            fontWeight: 600,
                            fontSize: "11px",
                          }}
                        />

                        <Chip
                          size="medium"
                          label={`Verified: ${scheduleTotals.verified}`}
                          sx={{
                            bgcolor: "#ede7f6",
                            color: "#5e35b1",
                            fontWeight: 600,
                            fontSize: "11px",
                          }}
                        />
                        {roleId == 1 && (
                          <Chip
                            size="medium"
                            label={`Courses: ${(selectedCourses[scheduleKey] || []).length}`}
                            sx={{
                              bgcolor: "#ede7f6",
                              color: "#b15635",
                              fontWeight: 600,
                              fontSize: "11px",
                            }}
                          />
                        )}
                        {roleId == 1 && (
                          <Button
                            variant="contained"
                            disabled={(selectedCourses[scheduleKey] || []).length === 0}
                            onClick={(e) => {
                              e.stopPropagation();

                              setSelectedSchedule({
                                exam_schedule_master_id: scheduleRows[0]?.exam_schedule_master_id,

                                valuation_schedule_master_id:
                                  scheduleRows[0]?.valuation_schedule_master_id,
                              });

                              fetchScrutinyStaff();
                              setScrutinyDialogOpen(true);
                            }}
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#115293",
                              },
                              borderRadius: "8px",
                              fontSize: "12px",
                              minHeight: "28px",
                              height: "28px",
                              padding: "0px 10px",
                              textTransform: "none",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Assign Scrutiny Staff
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Paper sx={{ p: 1 }}>
                      <DataGrid
                        rows={groupedCourses}
                        getRowId={(row) => row.exam_course_id}
                        autoHeight
                        columns={[
                          ...(roleId == 1
                            ? [
                                {
                                  field: "select",
                                  headerName: "",
                                  width: 70,
                                  sortable: false,
                                  filterable: false,
                                  disableColumnMenu: true,
                                  renderCell: (params) => (
                                    <Checkbox
                                      checked={(selectedCourses[scheduleKey] || []).includes(
                                        params.row.exam_course_id
                                      )}
                                      onChange={(e) => {
                                        const courseId = params.row.exam_course_id;

                                        setSelectedCourses((prev) => {
                                          const currentCourses = prev[scheduleKey] || [];

                                          if (e.target.checked) {
                                            return {
                                              ...prev,
                                              [scheduleKey]: [...currentCourses, courseId],
                                            };
                                          }

                                          return {
                                            ...prev,
                                            [scheduleKey]: currentCourses.filter(
                                              (id) => id !== courseId
                                            ),
                                          };
                                        });
                                      }}
                                    />
                                  ),
                                },
                              ]
                            : []),
                          {
                            field: "id",
                            headerName: "S.No",
                            width: 80,
                            valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
                          },
                          { field: "course_code", headerName: "Course Code", width: 150 },
                          { field: "course_name", headerName: "Course Name", flex: 1 },
                          { field: "staff_name", headerName: "Staff Name", width: 180 },
                          { field: "personal_mobile", headerName: "Mobile", width: 120 },
                          ...(roleId == 1
                            ? [
                                {
                                  field: "scrutiny_staff_name",
                                  headerName: "Scrutiny Staff",
                                  width: 220,
                                  renderCell: (params) =>
                                    params.row.scrutiny_staff_name ? (
                                      <Box>
                                        <Typography variant="body2" fontWeight={600}>
                                          {params.row.scrutiny_staff_name}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                          {params.row.scrutiny_staff_mobile}
                                        </Typography>
                                      </Box>
                                    ) : (
                                      <Chip label="Not Assigned" size="small" variant="outlined" />
                                    ),
                                },
                              ]
                            : []),
                          {
                            field: "total",
                            headerName: "Scripts",
                            width: 120,
                            align: "center",
                            renderCell: (params) =>
                              renderCountChip(params.value, "#e3f2fd", "#0288d1"),
                          },
                          {
                            field: "pending",
                            headerName: "Pending",
                            width: 120,
                            align: "center",
                            renderCell: (params) =>
                              renderCountChip(params.value, "#fff3e0", "#ed6c02"),
                          },
                          {
                            field: "completed",
                            headerName: "Completed",
                            width: 130,
                            align: "center",
                            renderCell: (params) =>
                              renderCountChip(params.value, "#e8f5e9", "#2e7d32"),
                          },
                          {
                            field: "verified",
                            headerName: "Verified",
                            width: 120,
                            align: "center",
                            renderCell: (params) =>
                              renderCountChip(params.value, "#ede7f6", "#5e35b1"),
                          },

                          {
                            field: "action",
                            headerName: "Start",
                            width: 150,
                            renderCell: (params) => {
                              const { total, verified } = params.row;

                              if (
                                Number(total) === Number(verified) &&
                                (roleId == 6 || roleId == 16)
                              ) {
                                return (
                                  <Typography variant="body2" color="success.main" fontWeight={500}>
                                    Completed
                                  </Typography>
                                );
                              }

                              return (
                                <Button
                                  variant="contained"
                                  startIcon={<PlayCircleIcon />}
                                  onClick={() => {
                                    const accordionKey = `${params.row.exam_schedule_master_id}_${params.row.valuation_schedule_master_id}`;

                                    setExpandedAccordion(scheduleKey);
                                    setSelectedSchedule({
                                      exam_schedule_master_id: params.row.exam_schedule_master_id,

                                      valuation_schedule_master_id:
                                        params.row.valuation_schedule_master_id,
                                    });

                                    setSelectedCourse(params.row.exam_course_id);
                                    setSelectedCourseCode(params.row.course_code);
                                    setSelectedCourseName(params.row.course_name);
                                  }}
                                  sx={{
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    "&:hover": { backgroundColor: "#115293" },
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    padding: "4px 12px",
                                    textTransform: "none",
                                  }}
                                >
                                  Start
                                </Button>
                              );
                            },
                          },
                        ]}
                        pageSize={pageSize}
                        onPageSizeChange={(n) => setPageSize(n)}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        pagination
                        disableRowSelectionOnClick
                      />
                      <Dialog
                        open={
                          scrutinyDialogOpen &&
                          scheduleKey ===
                            `${selectedSchedule?.exam_schedule_master_id}_${selectedSchedule?.valuation_schedule_master_id}`
                        }
                        onClose={() => setScrutinyDialogOpen(false)}
                        maxWidth="sm"
                        fullWidth
                      >
                        <DialogTitle>Assign Scrutiny Staff</DialogTitle>

                        <DialogContent>
                          {/* SELECTED COURSES */}
                          <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                            Selected Courses
                          </Typography>

                          <Box
                            sx={{
                              mb: 2,
                              border: "1px solid #ddd",
                              borderRadius: 1,
                              p: 1,
                              maxHeight: 180,
                              overflowY: "auto",
                            }}
                          >
                            {(() => {
                              const selectedCourseIds =
                                selectedCourses[
                                  `${selectedSchedule?.exam_schedule_master_id}_${selectedSchedule?.valuation_schedule_master_id}`
                                ] || [];

                              const selectedCourseRows = groupedCourses.filter((course) =>
                                selectedCourseIds.some(
                                  (id) => String(id) === String(course.exam_course_id)
                                )
                              );

                              return selectedCourseRows.length > 0 ? (
                                selectedCourseRows.map((course, index) => (
                                  <Box
                                    key={course.exam_course_id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      py: 0.7,
                                      borderBottom:
                                        index < selectedCourseRows.length - 1
                                          ? "1px solid #eee"
                                          : "none",
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        width: 30,
                                        color: "text.secondary",
                                      }}
                                    >
                                      {index + 1}.
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      fontWeight={600}
                                      sx={{ minWidth: 120 }}
                                    >
                                      {course.course_code}
                                    </Typography>

                                    <Typography variant="body2">{course.course_name}</Typography>
                                  </Box>
                                ))
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  No courses selected
                                </Typography>
                              );
                            })()}
                          </Box>

                          {/* SCRUTINY STAFF */}
                          <Autocomplete
                            options={staffList}
                            value={selectedStaff}
                            onChange={(event, newValue) => setSelectedStaff(newValue)}
                            getOptionLabel={(option) =>
                              `${option.staff_code} - ${option.staff_name}`
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Scrutiny Staff"
                                fullWidth
                                margin="normal"
                              />
                            )}
                          />
                        </DialogContent>

                        <DialogActions>
                          <Button onClick={() => setScrutinyDialogOpen(false)}>Cancel</Button>

                          <Button
                            variant="contained"
                            onClick={handleSaveScrutinyStaff}
                            disabled={!selectedStaff}
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#115293" },
                              borderRadius: "8px",
                              fontSize: "14px",
                              padding: "4px 12px",
                              textTransform: "none",
                            }}
                          >
                            Assign Scrutiny Staff
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Paper>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        ) : (
          /* === LAYER 2: SCRIPT LIST FOR SELECTED COURSE === */
          <>
            <Toolbar sx={{ gap: 1 }}>
              <Typography variant="h5" sx={{ flexGrow: 1 }}>
                COURSE: {selectedCourseCode}-{selectedCourseName} — {courseScripts.length} Scripts
              </Typography>

              <TextField
                size="medium"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="outlined"
                onClick={() => {
                  setSelectedCourse(null);
                  setSelectedSchedule(null);
                }}
                size="medium"
                sx={{
                  backgroundColor: "#1976d2", // custom blue
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#115293",
                  },
                  borderRadius: "8px",
                  fontSize: "12px",
                  padding: "2px 12px",
                }}
              >
                Back to Schedules{" "}
              </Button>
            </Toolbar>
            <Box sx={{ height: 560, ml: 2, mr: 2 }}>
              <DataGrid
                rows={filteredRows}
                columns={scriptColumns}
                getRowId={(row) => row.valuation_script_detail_id}
                loading={loading}
                pageSize={pageSize}
                onPageSizeChange={(n) => setPageSize(n)}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                pagination
                disableRowSelectionOnClick
              />
            </Box>
          </>
        )}
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
}
